import { SxGeneral } from "../../../../../../../utils/types/generals"

type SxStyles = SxGeneral<'container' | 'btnFooter' | 'evidenceContainer' | 'evidenceFooter' | 'actions' | 'map' | 'detail' | 'gridContainer' | 'cancelStyles'>

export const useStyles = (): SxStyles => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            height: '100%',
            justifyContent: 'space-between'
        },
        gridContainer: {
            width: '100%'
        },
        cancelStyles: {
            width: {width: '430px'}
        },
        detail: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        btnFooter: {
            width: '100%',
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
            gap: 2,
        },
        evidenceContainer: {
            height: '100%',
            padding: 3,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
        evidenceFooter: {

        },
        actions: {
            width: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: 1
        },
        map: {
            padding: 2,
            height: '100%',
            backgroundColor: 'blue.100',
            display: 'flex',
            flexDirection: 'column',
            gap: 2   
        }
    }
}